// extracted by mini-css-extract-plugin
export default {"messageParticipantPictureWrap":"MessageParticipantPicture_messageParticipantPictureWrap__eb4eE","initialsWrap":"MessageParticipantPicture_initialsWrap__wXm7c"};